import { ChangeEvent, ElementType, useEffect } from "react";
import AutoLayout from "../../../components/AutoLayout";
import SimpleDialog from "../../common/SimpleDialog";
import useExcelImport from "./import.leads.hooks";
import ExcelImportMapping from "./ExcelImportMapping";
import ExcelDialogErrors from "./ExcelDialogErrors";
import ExcelImportDetails from "./ExcelImportDetails";

type Props = {
    open: boolean,
    onClose: (importing: boolean) => void
}

const ExcelImportDialog = ({ open, onClose }: Props) => {
    const { resetImport, step, hasError, nextStep } = useExcelImport();

    useEffect(() => {
        if (open) {
            resetImport()
        }
    }, [open])

    return (
        <SimpleDialog open={open} onClose={()=> onClose(false)} size='sm' disabledCloseOnBackdropClick={true} disabledCloseOnEscape={true}>
            {step === 0 && <ExcelImportMapping onClose={()=> onClose(false)} />}
            {step === 1 && <ExcelImportDetails onClose={onClose} importing={false} />}
        </SimpleDialog>
    )
}

export default ExcelImportDialog;